
import { defineComponent, PropType, computed } from "vue";
import { StatusesEnum } from "@/store";
import { getCommonStatusLabel } from "@/utils/labels";

export default defineComponent({
  name: "StatusLabel",
  props: {
    label: {
      type: String as PropType<StatusesEnum>,
      required: true,
    },
  },
  setup(props) {
    const styleClass = computed(() => {
      let label = "tag ";
      if (props.label === StatusesEnum.ACTIVE) {
        label += "tag--success";
      } else if (
        props.label === StatusesEnum.DISABLE ||
        props.label === StatusesEnum.DISABLED
      ) {
        label += "tag--error";
      } else {
        label += "tag--default";
      }

      return label;
    });

    const statusLabel = computed(() => {
      return getCommonStatusLabel(props.label);
    });

    return {
      statusLabel,
      styleClass,
    };
  },
});
